module.exports = "pegasus_template/assets/blocks/column-6-theme6.png";